import { render, staticRenderFns } from "./Mini_Material.vue?vue&type=template&id=1f4823a3&scoped=true&"
import script from "./Mini_Material.vue?vue&type=script&lang=js&"
export * from "./Mini_Material.vue?vue&type=script&lang=js&"
import style0 from "./Mini_Material.vue?vue&type=style&index=0&id=1f4823a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4823a3",
  null
  
)

export default component.exports